// src/pages/Integrations/DeleteAccountModal.tsx
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import type { InstallationSummaryDTO } from "store/integrations/types";

interface Props extends WithTranslation {
  show: boolean;
  record: InstallationSummaryDTO;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteAccountModal: React.FC<Props> = ({
  t,
  show,
  record,
  onClose,
  onConfirm,
}) => {
  if (!record || !record.id) return null;

  return (
    <Modal isOpen={show} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        {t("Disconnect {{provider}}", { provider: record.name })}
      </ModalHeader>

      <ModalBody>
        {t("Are you sure you want to disconnect")}{" "}
        <strong>{record.name}</strong>?
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button color="danger" onClick={onConfirm}>
          {t("Disconnect")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default withTranslation()(DeleteAccountModal);
